import React from 'react';
import PropTypes from 'prop-types';
import l10n from '../../lib/reactPPl10nHelper';
import Page from '../../lib/page';

const NavBackArrow = function (props) {
  const backLabel = l10n.getContent('smarthelp/channelSelection.topicSelections.navigation.back');

  return (
    <div className="browser-back-container">
      <button className="browser-back-btn" onClick={props.onClick}>
        <span className={Page.getBackArrowDirectionStyle()} aria-hidden="true" />
        <span className="browser-back-text">{backLabel}</span>
      </button>
    </div>
  );
};

NavBackArrow.propTypes = {
  onClick: PropTypes.func,
};

NavBackArrow.defaultProps = {
  onClick: () => {},
};

export default NavBackArrow;
